import Vue from 'vue';
import App from './App.vue';
import router from './router';
import MyLibrary from 'my-library';

import 'animate.css';
import 'iconify-icon';
import 'vue-multiselect/dist/vue-multiselect.min.css';
import 'my-library/src/assets/scss/index.scss';

Vue.config.productionTip = false;

Vue.use(MyLibrary);

new Vue({
	router,
	render: (h) => h(App),
}).$mount('#app');
